import React from 'react';
import { DefaultTheme } from 'styled-components';
import { Select } from 'antd';
import { defineMessage, FormattedMessage, MessageDescriptor } from 'react-intl';
import { ReportType } from 'utils/apiClient/services/reports/types';

const reportTypes: Array<[ReportType, MessageDescriptor]> = [
  [ReportType.Hourly, defineMessage({ defaultMessage: 'Hourly' })],
  [ReportType.Daily, defineMessage({ defaultMessage: 'Daily' })],
  [ReportType.Weekly, defineMessage({ defaultMessage: 'Weekly' })],
];

const { Option } = Select;

type Props = {
  theme?: DefaultTheme;
  defaultValue?: ReportType;
  value: ReportType;
  handleChange: (type: ReportType) => void;
};

const ReportTypeSelect: React.FC<Props> = ({ value, handleChange }) => (
  <Select<ReportType>
    variant="borderless"
    popupMatchSelectWidth={false}
    value={value}
    css={`
      .ant-select-arrow {
        color: ${(p: Props) => p.theme?.primaryColor};
      }
      .ant-select-selection-item {
        color: ${(p: Props) => p.theme?.primaryColor};
      }
    `}
    onChange={(v) => handleChange(v)}
  >
    {reportTypes.map(([v, label]) => (
      <Option key={v} value={v}>
        <FormattedMessage {...label} />
      </Option>
    ))}
  </Select>
);

export default ReportTypeSelect;
